import {
  Backdrop,
  Fade,
  makeStyles,
  Modal as MaterialModal,
} from '@material-ui/core';
import React from 'react';
import { COLORS } from '../../../constants/colors';
import { MODAL } from '../../../constants/props';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  backdrop: {
    backgroundColor: COLORS.grayScale[1],
    opacity: '0.8 !important',
  },
  body: {
    height: 'min-content',
    padding: '2.625rem 3.5rem 1.875rem 3.5rem',
    backgroundColor: COLORS.grayScale[2],
    outline: 'none',
    border: '1px solid #444444',
    boxSizing: 'border-box',
    borderRadius: '0.3125rem',
    color: COLORS.grayScale[5],
  },
});

const Modal = ({ className, open, ...props }) => {
  const classes = useStyles();
  return (
    <MaterialModal
      open={open}
      className={classes.root}
      BackdropComponent={Backdrop}
      BackdropProps={{ className: classes.backdrop }}
      {...props}
    >
      <Fade in={open}>
        <div
          className={
            className ? [classes.body, className].join(' ') : classes.body
          }
        >
          {props.children}
        </div>
      </Fade>
    </MaterialModal>
  );
};

Modal.propTypes = {
  MODAL,
};

export default Modal;
